import { supabase } from '../../../lib/supabase';
import { addNumber } from '../../catalog/itemEdit';

/*
  PICK AN ACCOUNT EDGE ITEM FROM THE RUN, 12 October 2026, his word: "on the no
  vendor yet i need to be able to pick an account edge item".

  A line lands under "No vendor yet" when its ClaimSoft number is on no OnHand
  item. Found on JOB-00003: the crutches 10430-1, 10431-1 and 10432-1 (what the
  conversions say to buy instead of 10400-1, 10401-1 and 10402-1) ARE OnHand
  items, Drive Medical, carrying those Account Edge numbers; they just had no
  ClaimSoft number, and the run finds items by ClaimSoft number only.

  So he picks the Account Edge item, and **the line's ClaimSoft number is saved
  onto the OnHand item that carries that Account Edge number**, exactly as Add
  does on the item itself (`addNumber`): refused with nothing changed if the
  ClaimSoft number is on another item, or if that item already has a main
  ClaimSoft number. Saved for good, so the next job with it already knows.
*/
export async function linkClaimSoftToAe({ csNumber, aeNumber, userId }) {
  const key = String(aeNumber || '').trim().toUpperCase();
  const cs = String(csNumber || '').trim();
  if (!key || !cs) return { ok: false, error: { message: 'Pick an Account Edge item first.' } };
  const { data, error } = await supabase.from('org_item_numbers')
    .select('org_item:org_items(catalog_item_id)').eq('system', 'account_edge').eq('number_key', key).maybeSingle();
  if (error) return { ok: false, error };
  const catalogItemId = data && data.org_item ? data.org_item.catalog_item_id : null;
  if (!catalogItemId) {
    return { ok: false, error: { message: 'Account Edge ' + aeNumber + ' is not on any OnHand item yet, so there is nothing to put ClaimSoft ' + cs + ' on. Nothing was changed.' } };
  }
  return addNumber({ catalogItemId, system: 'claimsoft', number: cs, userId });
}
